import {createReducer, on} from '@ngrx/store';
import {
  AddGroupDetailsFailure,
  AddGroupDetailsRequest,
  AddGroupDetailsSuccess,
  ClearAutoGeneratedGroupName,
  ClearDuplicateGroup,
  ClearState,
  FetchClientFilterFailure,
  FetchClientFilterSuccess,
  FetchClientFilterRequest,
  FetchCoachesFilterRequest,
  FetchCoachesFilterSuccess,
  FetchGroupDetailsFailure,
  FetchGroupDetailsRequest,
  FetchGroupDetailsSuccess,
  FetchGroupNameFailure,
  FetchGroupNameRequest,
  FetchGroupNameSuccess,
  FetchGroupStatusFilterFailure,
  FetchGroupStatusFilterRequest,
  FetchGroupStatusFilterSuccess,
  FetchMeasurementsFilterFailure,
  FetchMeasurementsFilterRequest,
  FetchMeasurementsFilterSuccess,
  FetchSessionListFailure,
  FetchSessionListRequest,
  FetchSessionListSuccess,
  GenerateGroupNameFailure,
  GenerateGroupNameRequest,
  GenerateGroupNameSuccess,
  SetDuplicateGroupFailure,
  SetDuplicateGroupRequest,
  SetDuplicateGroupSuccess,
  UpdateGroupDetailsFailure,
  UpdateGroupDetailsRequest,
  UpdateGroupDetailsSuccess,
  VerifyGroupNameFailure,
  VerifyGroupNameRequest,
  VerifyGroupNameSuccess, FetchClientDetailsRequest, FetchClientDetailsSuccess, CreateGroupRequest, CreateGroupSuccess, CreateGroupFailure, ClearClientDetails, ClearGroupName,
} from "./group-details.actions";
import {Filter} from "../../../../models/filter";
import {FetchGroupDetailsModel} from "../models/fetch-group-details.model";
import {MetricOptionModel} from "../../../../models/metric-option.model";
import {FetchSessionListModel} from "../models/fetch-session-list.model";
import {FetchClientDetailsModel} from "../models/fetch-client-details.model";

export interface GroupDetailsState {
  groupDetails: {
    loading: boolean,
    details: FetchGroupDetailsModel['response']['data']
  },
  clientFilter: Filter,
  groupStatusFilter: Filter,
  measurementsFilter: {
    list: MetricOptionModel[],
    total: number,
    pageNumber: number,
    limit: number,
    hasNext: boolean,
    hasPrev: boolean,
    loading?: boolean
  },
  coachesFilter: Filter,
  autoGenerateGroupName: {
    loading: boolean,
    name: string
  },
  verifyGroupName: {
    loading: boolean,
    isAvailable: boolean
  },
  sessionList: {
    list: FetchSessionListModel['response']['data'],
    loading: boolean
  },
  groupName: {
    loading: boolean,
    name: string,
    startDate: string
  }
  duplicateGroup: {
    loading: boolean,
    details: FetchGroupDetailsModel['response']['data']
  },
  clientDetails: {
    loading: boolean,
    details: FetchClientDetailsModel['response']['data']
  }
}

const initialState: GroupDetailsState = {
  groupDetails: {
    loading: false,
    details: null
  },
  clientFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  groupStatusFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  measurementsFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  coachesFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  autoGenerateGroupName: {
    loading: false,
    name: null
  },
  verifyGroupName: {
    loading: false,
    isAvailable: null
  },
  sessionList: {
    list: [],
    loading: false
  },
  groupName: {
    loading: false,
    name: '',
    startDate: null
  },
  duplicateGroup: {
    loading: false,
    details: null
  },
  clientDetails: {
    loading: false,
    details: null
  }
};

export const reducer = createReducer(
  initialState,

  //clear state
  on(ClearState, (state) => initialState),

  // FETCH CLIENT FILTER LIST
  on(FetchClientFilterRequest, (state, props) => ({
    ...state,
    clientFilter: {
      ...(props.payload.pageNumber === 1 ? {
        ...initialState.clientFilter
      }: {...state.clientFilter}),
      loading: true
    }
  })),
  on(FetchClientFilterSuccess, (state, props) => ({
    ...state,
    clientFilter: {
      ...props.clientFilter,
      list: [
        ...(props.pageNumber > 1 ? [
          ...state.clientFilter.list,
          ...props.clientFilter.list
        ] : props.clientFilter.list)
      ],
      loading: false
    }
  })),
  on(FetchClientFilterFailure, (state) => ({
    ...state,
    clientFilter: {
      ...state.clientFilter,
      loading: false
    }
  })),

  // FETCH GROUP STATUS FILTER LIST
  on(FetchGroupStatusFilterRequest, (state) => ({
    ...state,
    groupStatusFilter: {
      ...initialState.groupStatusFilter,
      loading: true
    }
  })),
  on(FetchGroupStatusFilterSuccess, (state, props) => ({
    ...state,
    groupStatusFilter: {
      ...props.groupStatusFilter,
      loading: false
    }
  })),
  on(FetchGroupStatusFilterFailure, (state) => ({
    ...state,
    groupStatusFilter: {
      ...state.groupStatusFilter,
      loading: false
    }
  })),

  // FETCH MEASUREMENTS FILTER LIST
  on(FetchMeasurementsFilterRequest, (state) => ({
    ...state,
    measurementsFilter: {
      ...initialState.measurementsFilter,
      loading: true
    }
  })),
  on(FetchMeasurementsFilterSuccess, (state, props) => ({
    ...state,
    measurementsFilter: {
      ...props.measurementsFilter,
      loading: false
    }
  })),
  on(FetchMeasurementsFilterFailure, (state) => ({
    ...state,
    measurementsFilter: {
      ...state.measurementsFilter,
      loading: false
    }
  })),

  // FETCH COACHES FILTER LIST
  on(FetchCoachesFilterRequest, (state,props) => ({
    ...state,
    coachesFilter: {
      ...initialState.coachesFilter,
      loading: true,
      ...(props.payload.pageNumber ? props.payload.pageNumber === 1 ? { list: [] } : {list: state.coachesFilter.list} : []),
    }
  })),
  on(FetchCoachesFilterSuccess, (state, props) => ({
    ...state,
    coachesFilter: {
      ...props.coachesFilter,
      loading: false,
      ...(props.coachesFilter.pageNumber ? props.coachesFilter.pageNumber === 1 ? {list: props.coachesFilter.list} : {
        list: [
          ...state.coachesFilter.list, ...props.coachesFilter.list
        ]
      } : []),
    }
  })),
  on(FetchClientFilterFailure, (state) => ({
    ...state,
    coachesFilter: {
      ...state.coachesFilter,
      loading: false
    }
  })),

  // AUTO GENERATE GROUP NAME
  on(GenerateGroupNameRequest, (state) => ({
    ...state,
    autoGenerateGroupName: {
      ...state.autoGenerateGroupName,
      loading: true
    }
  })),
  on(GenerateGroupNameSuccess, (state, props) => ({
    ...state,
    autoGenerateGroupName: {
      loading: false,
      name: props.name
    }
  })),
  on(GenerateGroupNameFailure, (state) => ({
    ...state,
    autoGenerateGroupName: {
      ...initialState.autoGenerateGroupName,
      loading: false
    }
  })),

  // CLEAR AUTO GENERATED GROUP NAME
  on(ClearAutoGeneratedGroupName, (state) => ({
    ...state,
    autoGenerateGroupName: {
      ...initialState.autoGenerateGroupName
    }
  })),

  // VERIFY GROUP NAME
  on(VerifyGroupNameRequest, (state, props) => ({
    ...state,
    verifyGroupName: {
      ...initialState.verifyGroupName,
      loading: true
    }
  })),
  on(VerifyGroupNameSuccess, (state, props) => ({
    ...state,
    verifyGroupName: {
      loading: false,
      isAvailable: props.isAvailable
    }
  })),
  on(VerifyGroupNameFailure, (state) => ({
    ...state,
    verifyGroupName: {
      ...state.verifyGroupName,
      loading: false,
    }
  })),
  
  on(ClearGroupName, (state) => ({
    ...state,
    verifyGroupName: {
      ...initialState.verifyGroupName,
      loading: false,
    }
  })),

  // ADD GROUP DETAILS
  on(AddGroupDetailsRequest, (state, props) => ({
    ...state,
    groupDetails: {
      ...initialState.groupDetails,
      loading: true
    },
    groupName: {
      ...initialState.groupName,
      loading: true,
    }
  })),
  on(AddGroupDetailsSuccess, (state, props) => ({
    ...state,
    groupDetails: {
      loading: false,
      details: props.groupDetails
    },
    groupName: {
      loading: false,
      name: props.groupDetails['name'],
      startDate: props.groupDetails['startDate']
    }
  })),
  on(AddGroupDetailsFailure, (state) => ({
    ...state,
    groupDetails: {
      ...state.groupDetails,
      loading: false,
    },
    groupName: {
      ...state.groupName,
      loading: false,
    }
  })),

  // UPDATE GROUP DETAILS
  on(UpdateGroupDetailsRequest, (state, props) => ({
    ...state,
    groupDetails: {
      ...initialState.groupDetails,
      loading: true
    },
    groupName: {
      ...initialState.groupName,
      loading: true,
    }
  })),
  on(UpdateGroupDetailsSuccess, (state, props) => ({
    ...state,
    groupDetails: {
      loading: false,
      details: props.groupDetails
    },
    groupName: {
      loading: false,
      name: props.groupDetails['name'],
      startDate: props.groupDetails['startDate']
    }
  })),
  on(UpdateGroupDetailsFailure, (state) => ({
    ...state,
    groupDetails: {
      ...state.groupDetails,
      loading: false,
    },
    groupName: {
      ...state.groupName,
      loading: false,
    }
  })),

  // create group

  on(CreateGroupRequest,(state)=>({
    ...state,
    groupDetails:{
      ...state.groupDetails,
      loading:true,
    }
  })),

  on(CreateGroupSuccess,(state)=>({
    ...state,
    groupDetails:{
      ...state.groupDetails,
      loading:false,
    }
  })),

  on(CreateGroupFailure,(state)=>({
    ...state,
    groupDetails:{
      ...state.groupDetails,
      loading:false,
    }
  })),

  // FETCH GROUP DETAILS
  on(FetchGroupDetailsRequest, (state) => ({
    ...state,
    groupDetails: {
      ...initialState.groupDetails,
      loading: true
    },
    groupName: {
      ...initialState.groupName,
      loading: true
    }
  })),
  on(FetchGroupDetailsSuccess, (state, props) => ({
    ...state,
    groupDetails: {
      loading: false,
      details: props.groupDetails
    },
    groupName: {
      loading: false,
      name: props.groupDetails['name'],
      startDate: props.groupDetails['startDate']
    }
  })),
  on(FetchGroupDetailsFailure, (state) => ({
    ...state,
    groupDetails: {
      ...state.groupDetails,
      loading: false,
    },
    groupName: {
      ...state.groupName,
      loading: false
    }
  })),

  // FETCH SESSION LIST
  on(FetchSessionListRequest, (state) => ({
    ...state,
    sessionList: {
      ...initialState.sessionList,
      loading: true
    }
  })),
  on(FetchSessionListSuccess, (state, props) => ({
    ...state,
    sessionList: {
      list: props.sessionList,
      loading: false,
    }
  })),
  on(FetchSessionListFailure, (state) => ({
    ...state,
    sessionList: {
      ...state.sessionList,
      loading: false
    }
  })),


  // SET DUPLICATE GROUP
  on(SetDuplicateGroupRequest, (state) => ({
    ...state,
    duplicateGroup: {
      ...initialState.duplicateGroup,
      loading: true
    }
  })),
  on(SetDuplicateGroupSuccess, (state, props) => ({
    ...state,
    duplicateGroup: {
      loading: false,
      details: props.groupDetails
    }
  })),
  on(SetDuplicateGroupFailure, (state) => ({
    ...state,
    duplicateGroup: {
      ...state.duplicateGroup,
      loading: false,
    }
  })),

  // CLEAR DUPLICATE GROUP
  on(ClearDuplicateGroup, (state) => ({
    ...state,
    duplicateGroup: {
      details: null,
      loading: false,
    }
  })),

  // FETCH GROUP NAME
  on(FetchGroupNameRequest, (state) => ({
    ...state,
    groupName: {
      ...initialState.groupName,
      loading: true
    }
  })),
  on(FetchGroupNameSuccess, (state, props) => ({
    ...state,
    groupName: {
      loading: false,
      name: props.name,
      startDate: props.startDate
    }
  })),
  on(FetchGroupNameFailure, (state) => ({
    ...state,
    groupName: initialState.groupName
  })),

  // FETCH CLIENT DETAILS
  on(FetchClientDetailsRequest, (state) => ({
    ...state,
    clientDetails: {
      ...initialState.clientDetails,
      loading: true,
    }
  })),
  
  on(FetchClientDetailsSuccess, (state, props) => ({
    ...state,
    clientDetails: {
      loading: false,
      details: props.clientDetails
    }
  })),

  on(FetchClientFilterFailure, (state) => ({
    ...state,
    clientDetails: initialState.clientDetails
  })),
  
  on(ClearClientDetails, (state) => ({
    ...state,
    clientDetails: {
      ...initialState.clientDetails,
      loading: true,
    }
  })),
);
